var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"etichetta",style:({ 'background-color' : (_vm.stato.color || 'grey') })},[_vm._v(_vm._s(_vm.stato.label || 'ciao'))])}
var staticRenderFns = []

export { render, staticRenderFns }